import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { usePayee, Payee } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<Payee>
      useData={usePayee}
      config={{
        ...moduleConfig,
        getInitialFormData: getInitialFormData as () => Partial<Payee>,
        mapItemToFormData: mapItemToFormData as (item: Payee) => Partial<Payee>,
      }}
    />
  );
};

export default Form;
